import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sparkle, ArrowsLeftRight, ArrowRight, ChatCircle } from '@phosphor-icons/react';

export default function OnboardingModal({ onDismiss }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/20 backdrop-blur-sm px-4"
      data-testid="onboarding-modal"
    >
      <motion.div
        initial={{ opacity: 0, y: 20, scale: 0.97 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
        className="bg-white/5 rounded-2xl shadow-xl border border-white/10 max-w-md w-full overflow-hidden"
      >
        {/* Header */}
        <div className="p-8 pb-0 text-center">
          <div className="w-14 h-14 rounded-xl bg-lime-400/100 flex items-center justify-center mx-auto mb-5 shadow-lg shadow-lime-500/15">
            <Sparkle weight="fill" className="w-7 h-7 text-white" />
          </div>
          <h2 className="text-xl font-semibold tracking-tight mb-2" style={{ fontFamily: 'Clash Display, sans-serif' }}>
            Welcome to Lindey
          </h2>
          <p className="text-sm text-white/50 leading-relaxed">
            Your personal AI assistant for code, math, writing, images, and more. Let's get you started.
          </p>
        </div>

        {/* Options */}
        <div className="p-6 space-y-3">
          <Link
            to="/app/import"
            className="flex items-center gap-4 p-4 rounded-xl border border-white/10 hover:border-lime-400/25 hover:bg-lime-400/10 transition-all group"
            data-testid="onboarding-import"
          >
            <div className="w-10 h-10 rounded-lg bg-lime-400/10 border border-lime-400/20 flex items-center justify-center shrink-0">
              <ArrowsLeftRight weight="duotone" className="w-5 h-5 text-lime-400" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-white/90">Import from ChatGPT or Claude</p>
              <p className="text-xs text-white/50 mt-0.5">Bring all your existing conversations</p>
            </div>
            <ArrowRight className="w-4 h-4 text-white/40 group-hover:text-lime-400 transition-colors" />
          </Link>

          <button
            onClick={onDismiss}
            className="flex items-center gap-4 p-4 rounded-xl border border-white/10 hover:border-white/25 hover:bg-white/10 transition-all group w-full text-left"
            data-testid="onboarding-start-fresh"
          >
            <div className="w-10 h-10 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center shrink-0">
              <ChatCircle weight="duotone" className="w-5 h-5 text-white/50" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-white/90">Start fresh</p>
              <p className="text-xs text-white/50 mt-0.5">Jump right into chatting with Lindey</p>
            </div>
            <ArrowRight className="w-4 h-4 text-white/40 group-hover:text-white/80 transition-colors" />
          </button>
        </div>

        <div className="px-6 pb-5">
          <p className="text-[10px] text-white/40 text-center">You can always import chats later from the sidebar</p>
        </div>
      </motion.div>
    </motion.div>
  );
}
